module.exports = __webpack_public_path__ + "fonts/Corpos.89765fca.ttf";